import { is } from 'effector';

import * as EffectorReact from 'effector-react';

import { createLib } from 'effector-view';

const { createView, connect } = createLib({ ...EffectorReact, is });

export { createView, connect };
